import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Directive({
    selector: '[appClickedOutside]',
    standalone: false
})
export class ClickedOutsideDirective {
  @Output() clickedOutside = new EventEmitter<void>();
  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.clickedOutside.emit();
    }
  }

  @HostListener('document:keyup.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.clickedOutside.emit();
  }
}
